import { render, staticRenderFns } from "./StartForm6.vue?vue&type=template&id=09de90bd&scoped=true"
import script from "./StartForm6.vue?vue&type=script&lang=ts"
export * from "./StartForm6.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09de90bd",
  null
  
)

export default component.exports